import { render, staticRenderFns } from "./Crypto.vue?vue&type=template&id=2c189222&scoped=true"
import script from "./Crypto.vue?vue&type=script&lang=js"
export * from "./Crypto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c189222",
  null
  
)

export default component.exports